import { Route } from "react-router";
import Faq from "./pages/Faq";
import NotFound from "./pages/404";
import IFrame from "./pages/IFrame";
import Layout from "./components/layout/Layout";
import DeadEnd from "./pages/continente-credentials/DeadEnd";
import Blocked from "./pages/continente-credentials/Blocked";
import ContactCenter from "./pages/continente-credentials/ContactCenter";
import { AuthStartQueryPage, AuthStartRoutePage } from "./pages/continente-credentials/auth/AuthStartPage";

import TermsAndConditions from "./pages/continente-credentials/TermsAndConditions";

import { LoyaltyCardOtpOptions } from "./pages/shared/loyaltyCard/SharedLoyaltyCardOtpOptions";
import LoyaltyCardCreation from "./pages/continente-credentials/loyaltycard/LoyaltyCardCreation";
import { LoyaltyCardAssociation } from "./pages/shared/loyaltyCard/LoyaltyCardAssociation";
import LoyaltyCcvCommunication from "./pages/continente-credentials/loyaltycard/LoyaltyCcvCommunication";
import LoyaltyCardContactCenter from "./pages/continente-credentials/loyaltycard/LoyaltyCardContactCenter";
import LoyaltyCardOtpValidation from "./pages/continente-credentials/loyaltycard/LoyaltyCardOtpValidation";
import IdentificationVerification from "./pages/continente-credentials/loyaltycard/IdentificationVerification";
import LoyaltyCardAssociationSuccess from "./pages/continente-credentials/loyaltycard/LoyaltyCardAssociationSuccess";

import { EmailAssociationVerifyOtp } from "./pages/shared/SharedVerifyOtpPage";
import { EmailAssociation } from "./pages/shared/SharedAssociateIdentifierPage";
import { PhoneRegistrationSetPassword } from "./pages/shared/SharedSetPasswordPage";
import { PhoneNumberRegistrationEmailAssociation } from "./pages/shared/SharedAssociateIdentifierPage";
import { PasswordRecoverEmailValidateOtp, PhoneNumberVerifyOtp, PhoneNumberFreshStartVerifyOtp } from "./pages/shared/SharedVerifyOtpPage";
import FreshStartRelease from "./pages/continente-credentials/phonenumber/login/FreshStartRelease";
import FreshStartSuccess from "./pages/continente-credentials/phonenumber/login/FreshStartSuccess";
import { FreshStartOrigin } from "./config/FreshStartOriginConfig";
import { PhonenumberRegistrationValidatePasswordEmailAssociation } from "./pages/shared/SharedValidatePasswordPage";

import { EmailVerifyOtp } from "./pages/shared/SharedVerifyOtpPage";
import { EmailPinValidation } from "./pages/shared/SharedVerifyPinPage";
import { PhonePinValidation } from "./pages/shared/SharedVerifyPinPage";
import { SharedRecoverPinPage } from "./pages/shared/SharedRecoverPinPage";
import { PhoneNumberAssociationVerifyOtp } from "./pages/shared/SharedVerifyOtpPage";
import { EmailLoginValidatePassword } from "./pages/shared/SharedValidatePasswordPage";
import { PhonenumberLoginValidatePassword } from "./pages/shared/SharedValidatePasswordPage";
import { PhonenumberLoginValidatePasswordEmailAssociation } from "./pages/shared/SharedValidatePasswordPage";
import { EmailLoginValidatePasswordPhoneNumberAssociation } from "./pages/shared/SharedValidatePasswordPage";
import { EmailRegistrationValidatePasswordPhoneAssociation } from "./pages/shared/SharedValidatePasswordPage";
import { EmailRegistrationSetPassword, PhoneLoginEmailAssociationSetPassword } from "./pages/shared/SharedSetPasswordPage";

import { PasswordRecoverSetPassword } from "./pages/shared/SharedSetPasswordPage";
import SuccessMessage from "./pages/continente-credentials/password-recover/SuccessMessage";
import LoyaltyCardValidation from "./pages/continente-credentials/password-recover/LoyaltyCardValidation";
import { PasswordRecoverPhoneNumberValidateOtp, PasswordRecoverPhoneNumberValidateOtpEmail } from "./pages/shared/SharedVerifyOtpPage";

import { EmailMfaValidation } from "./pages/shared/SharedVerifyOtpPage";
import AuthorizeSSO from "./pages/continente-credentials/AuthorizeSSO";
import AuthorizeSRT from "./pages/continente-credentials/AuthorizeSRT";
import { SRTValidatePassword } from "./pages/shared/SharedValidatePasswordPage";
import { PhoneAssociation } from "./pages/shared/SharedAssociateIdentifierPage";

import { PhoneNumberMfaValidation } from "./pages/shared/SharedVerifyOtpPage";
import SharedAccountAssociationOptions from "./pages/shared/SharedAccountAssociationOptions";

import KeepMeLoggedIn from "./pages/continente-credentials/KeepMeLoggedInPage";
import WelcomeBack from "./pages/continente-credentials/WelcomeBackPage";
import { AuthSuccessQueryPage, AuthSuccessRoutePage } from "./pages/continente-credentials/auth/AuthSuccessPage";

import { ConsentAuthorization } from "./pages/shared/consent/ConsentAuthorizationScreenPage";
import { ConsentDeclineConfirmation } from "./pages/shared/consent/ConsentDeclineConfirmationPage";

const { fetch: originalFetch } = window;

const cookies: Record<string, string> = {};

async function fetch(
  input: RequestInfo | URL,
  init: RequestInit = {}
): Promise<Response> {
  const cookieNames = Object.keys(cookies);

  if (cookieNames.length > 0) {
    const cookieHeader = cookieNames
      .map((c) => `${c}=${cookies[c]}`)
      .join("; ");

    init.headers = {
      ...init.headers,
      "X-Cookie": cookieHeader,
    };
  }

  const response = await originalFetch(input, init);

  const setCookieHeader = response.headers.get("X-Set-Cookie");

  if (setCookieHeader) {
    setCookieHeader.split(",").map((cookie, index) => {
      const parts = cookie.split("=");
      if (parts.length >= 2) {
        cookies[parts[0]] = parts[1].split(";")[0];
      }
    });
  }

  return response;
}

window.fetch = fetch;

export default function SdkApp() {
  return (
    <Layout className="self-center max-w-[40ch] w-full px-8 mx-auto h-full content-center">
      <Route
        path="/iframe"
        component={IFrame}
      />
      <Route
        path="/user-register"
        component={AuthStartQueryPage}
      />
      <Route
        exact path="/consents"
        component={ConsentAuthorization}
      />
      <Route
        path="/consents/decline"
        component={ConsentDeclineConfirmation}
      />
      <Route
        path="/sso/keep-me-logged-in"
        component={KeepMeLoggedIn}
      />
      <Route
        path="/sso/welcome-back/:clientId"
        component={WelcomeBack}
      />
      <Route
        exact path="/auth/:clientId"
        component={AuthStartRoutePage}
      />
      <Route
        exact path="/auth"
        component={AuthStartQueryPage}
      />
      <Route
        path="/dead-end"
        component={DeadEnd}
      />
      <Route
        exact path="/auth/success/:clientId"
        component={AuthSuccessRoutePage}
      />
      <Route
        exact path="/auth/success"
        component={AuthSuccessQueryPage}
      />
      <Route
        path="/contact-center"
        render={() => <ContactCenter freshStartOrigin={FreshStartOrigin.PASSWORD_RECOVER_CONTACT_CENTER} />}
      />
      <Route
        path="/authorize/sso"
        component={AuthorizeSSO} // TODO: novo design - validar SSO Token 
      />
      <Route
        path="/authorize/srt"
        component={AuthorizeSRT} // TODO: novo design - validar SRT Token
      />
      <Route
        path="/loyalty/cards/otp-options"
        component={LoyaltyCardOtpOptions}
      />
      <Route
        path="/loyalty/cards/verify-otp"
        component={LoyaltyCardOtpValidation}
      />
      <Route
        path="/card/continente-card-association"
        component={LoyaltyCardAssociation}
      />
      {/* <Route // We removed this due to not having a flow that leads to this page
        path="/card/continente-card-association-success"
        component={LoyaltyCardAssociationSuccess} 
      /> */}
      <Route
        path="/card/continente-card-creation"
        component={LoyaltyCardCreation}
      />
      <Route
        path="/card/call-center-loyalty-card"
        component={LoyaltyCardContactCenter}
      />
      <Route
        path="/card/identifier-verification"
        component={IdentificationVerification}
      />
      <Route
        path="/card/loyalty-card-association-success"
        component={LoyaltyCardAssociationSuccess}
      />
      <Route
        path="/phonenumber/registration/verify-otp"
        component={PhoneNumberVerifyOtp}
      />
      <Route
        path="/phonenumber/registration/email-verify-otp"
        component={EmailAssociationVerifyOtp}
      />
      <Route
        path="/phonenumber/registration/email-association"
        component={PhoneNumberRegistrationEmailAssociation}
      />
      <Route
        path="/phonenumber/registration/set-password"
        component={PhoneRegistrationSetPassword}
      />
      <Route
        path="/phonenumber/registration/validate-password"
        component={PhonenumberRegistrationValidatePasswordEmailAssociation}
      />
      <Route
        path="/phonenumber/registration/email-mfa-validation"
        component={EmailMfaValidation}
      />
      <Route
        path="/phonenumber/login/validate-password"
        component={PhonenumberLoginValidatePassword}
      />
      <Route
        path="/phonenumber/login/validate-password-email"
        component={PhonenumberLoginValidatePasswordEmailAssociation}
      />
      <Route
        path="/phonenumber/login/set-password-email"
        component={PhoneLoginEmailAssociationSetPassword}
      />
      <Route
        path="/phonenumber/login/email-association"
        component={EmailAssociation}
      />
      <Route
        path="/phonenumber/login/verify-pin"
        component={PhonePinValidation}
      />
      <Route
        path="/phonenumber/login/recover-pin"
        component={SharedRecoverPinPage}
      />
      <Route
        path="/phonenumber/login/verify-otp"
        component={PhoneNumberVerifyOtp}
      />
      <Route
        path="/phonenumber/login/fresh-start/verify-otp"
        component={PhoneNumberFreshStartVerifyOtp}
      />
      <Route
        path="/phonenumber/login/fresh-start/release"
        component={FreshStartRelease}
      />
      <Route
        path="/phonenumber/login/fresh-start/success"
        component={FreshStartSuccess}
      />
      <Route
        path="/phonenumber/login/email-association-verify-otp"
        component={EmailAssociationVerifyOtp}
      />
      <Route
        path="/phonenumber/login/loyalty-card-association-option"
        component={SharedAccountAssociationOptions}
      />
      <Route
        path="/phonenumber/login/email-mfa-validation"
        component={EmailMfaValidation}
      />
      <Route
        path="/phonenumber/login/phonenumber-mfa-validation"
        component={PhoneNumberMfaValidation}
      />
      <Route
        path="/email/login/validate-password"
        component={EmailLoginValidatePassword}
      />
      <Route
        path="/email/login/phonenumber-association"
        component={PhoneAssociation}
      />
      <Route
        path="/email/login/new-phonenumber-verify-otp"
        component={PhoneNumberAssociationVerifyOtp}
      />
      <Route
        path="/email/login/phonenumber-verify-otp"
        component={PhoneNumberAssociationVerifyOtp}
      />
      <Route
        path="/email/login/phonenumber-pin-verify-otp"
        component={PhoneNumberAssociationVerifyOtp}
      />
      <Route
        path="/email/login/validate-password-phonenumber"
        component={EmailLoginValidatePasswordPhoneNumberAssociation}
      />
      <Route
        path="/email/login/validate-pin-phonenumber"
        component={PhonePinValidation}
      />
      <Route
        path="/email/login/recover-pin"
        component={SharedRecoverPinPage}
      />
      <Route
        path="/email/login/loyalty-card-association-option"
        component={SharedAccountAssociationOptions}
      />
      <Route
        path="/email/login/email-mfa-validation"
        component={EmailMfaValidation}
      />
      <Route
        path="/email/login/phonenumber-mfa-validation"
        component={PhoneNumberMfaValidation}
      />
      <Route
        path="/email/registration/verify-otp"
        component={EmailVerifyOtp}
      />
      <Route
        path="/email/registration/set-password"
        component={EmailRegistrationSetPassword}
      />
      <Route
        path="/email/registration/verify-pin"
        component={EmailPinValidation}
      />
      <Route
        path="/email/registration/recover-pin"
        component={SharedRecoverPinPage}
      />
      <Route
        path="/email/registration/phonenumber-association"
        component={PhoneAssociation}
      />
      <Route
        path="/email/registration/verify-password"
        component={EmailRegistrationValidatePasswordPhoneAssociation}
      />
      <Route
        path="/email/registration/pin-set-password"
        component={EmailRegistrationSetPassword}
      />
      <Route
        path="/email/registration/phonenumber-set-password"
        component={EmailRegistrationSetPassword}
      />
      <Route
        path="/email/registration/phonenumber-otp-validation"
        component={PhoneNumberAssociationVerifyOtp}
      />
      <Route
        path="/email/registration/phonenumber-mfa-validation"
        component={PhoneNumberMfaValidation}
      />
      <Route
        path="/password-recover/blocked"
        render={() => <Blocked faqAnchor={""} freshStartOrigin={FreshStartOrigin.PASSWORD_RECOVER_BLOCKED} />}
      />
      <Route
        path="/password-recover/validate-otp"
        component={PasswordRecoverPhoneNumberValidateOtp}
      />
      <Route
        path="/password-recover/set-password"
        component={PasswordRecoverSetPassword}
      />
      <Route
        path="/password-recover/validate-otp-email"
        component={PasswordRecoverEmailValidateOtp}
      />
      <Route
        path="/password-recover/phonenumber-validate-otp-email"
        component={PasswordRecoverPhoneNumberValidateOtpEmail} // TODO: validar password-recover/phonenumber-validate-otp-email
      />
      <Route
        path="/password-recover/success-message"
        component={SuccessMessage}
      />
      <Route
        path="/password-recover/loyalty-card-validation"
        component={LoyaltyCardValidation} // TODO: validar password-recover/loyalty-card-validation
      />
      <Route
        path="/card/ccv-communication"
        component={LoyaltyCcvCommunication}
      />
      <Route
        path="/srt/validate-password"
        component={SRTValidatePassword}
      />
      <Route
        path="/pin-recover/blocked"
        render={() => <Blocked faqAnchor={""} freshStartOrigin={FreshStartOrigin.PHONE_LOGIN_PIN_BLOCKED} />}
      />
      <Route
        path="/terms-and-conditions"
        component={TermsAndConditions}
      />
      <Route
        path="/continente-credentials/faq"
        component={Faq}
      />
    </Layout>
  );
}